module.exports = __webpack_public_path__ + "static/img/part3.f75162d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part3.svg
// module id = UXaE
// module chunks = 0